// Top 300 high-income areas worldwide targeting mothers
export const HIGH_INCOME_LOCATIONS = [
// North America
"Manhattan NY", "San Francisco CA", "Los Angeles CA", "Seattle WA", "Boston MA",
"Washington DC", "Chicago IL", "San Diego CA", "Austin TX", "Denver CO",
"Portland OR", "Miami FL", "Atlanta GA", "Dallas TX", "Houston TX",
"Toronto Canada", "Vancouver Canada", "Calgary Canada", "Montreal Canada",

// Europe
"London UK", "Monaco", "Zurich Switzerland", "Geneva Switzerland", "Oslo Norway",
"Copenhagen Denmark", "Stockholm Sweden", "Helsinki Finland", "Amsterdam Netherlands",
"Paris France", "Luxembourg", "Dublin Ireland", "Edinburgh Scotland", "Brussels Belgium",
"Vienna Austria", "Munich Germany", "Frankfurt Germany", "Hamburg Germany", "Berlin Germany",
"Milan Italy", "Rome Italy", "Barcelona Spain", "Madrid Spain", "Lisbon Portugal",
"Reykjavik Iceland", "Bergen Norway", "Gothenburg Sweden", "Malmö Sweden",

// Asia-Pacific
"Singapore", "Hong Kong", "Tokyo Japan", "Seoul South Korea", "Sydney Australia",
"Melbourne Australia", "Brisbane Australia", "Perth Australia", "Auckland New Zealand",
"Wellington New Zealand", "Dubai UAE", "Abu Dhabi UAE", "Tel Aviv Israel",
"Shanghai China", "Beijing China", "Shenzhen China", "Taipei Taiwan",

// Additional High-Income Cities
"San Jose CA", "Palo Alto CA", "Mountain View CA", "Cupertino CA", "Redmond WA",
"Bellevue WA", "Cambridge MA", "Brookline MA", "Greenwich CT", "Stamford CT",
"Jersey City NJ", "Hoboken NJ", "Arlington VA", "Alexandria VA", "Bethesda MD",
"Scottsdale AZ", "Boulder CO", "Aspen CO", "Naples FL", "Palm Beach FL",
"Beverly Hills CA", "Santa Monica CA", "Pasadena CA", "Irvine CA", "Newport Beach CA",
"Honolulu HI", "Anchorage AK", "Charleston SC", "Savannah GA", "Raleigh NC",
"Charlotte NC", "Nashville TN", "Minneapolis MN", "Madison WI", "Ann Arbor MI",
"Pittsburgh PA", "Philadelphia PA", "Baltimore MD", "Richmond VA", "Columbus OH",
"Indianapolis IN", "Kansas City MO", "St. Louis MO", "Oklahoma City OK", "Tulsa OK",
"Salt Lake City UT", "Boise ID", "Spokane WA", "Eugene OR", "Sacramento CA",
"Fresno CA", "Bakersfield CA", "Las Vegas NV", "Reno NV", "Phoenix AZ",
"Tucson AZ", "Albuquerque NM", "El Paso TX", "San Antonio TX", "Fort Worth TX",
"Plano TX", "Irving TX", "Frisco TX", "The Woodlands TX", "Sugar Land TX",
"Katy TX", "Pearland TX", "League City TX", "Round Rock TX", "Cedar Park TX",
"Pflugerville TX", "Georgetown TX", "Leander TX", "McKinney TX", "Allen TX",
"Richardson TX", "Garland TX", "Mesquite TX", "Grand Prairie TX", "Arlington TX",
"Denton TX", "Carrollton TX", "Flower Mound TX", "Coppell TX", "Southlake TX",
"Colleyville TX", "Grapevine TX", "Euless TX", "Bedford TX", "Hurst TX",
"North Richland Hills TX", "Mansfield TX", "Burleson TX", "Cleburne TX", "Waxahachie TX",
"Midlothian TX", "Red Oak TX", "Lancaster TX", "DeSoto TX", "Cedar Hill TX",
"Duncanville TX", "Glenn Heights TX", "Hutchins TX", "Wilmer TX", "Seagoville TX",
"Balch Springs TX", "Sunnyvale TX", "Forney TX", "Terrell TX", "Kaufman TX",
"Rockwall TX", "Rowlett TX", "Wylie TX", "Murphy TX", "Parker TX",
"Lucas TX", "Fairview TX", "Prosper TX", "Celina TX", "Little Elm TX",
"The Colony TX", "Frisco TX", "Lewisville TX", "Highland Village TX", "Double Oak TX",
"Bartonville TX", "Copper Canyon TX", "Hickory Creek TX", "Lake Dallas TX", "Corinth TX",
"Shady Shores TX", "Krugerville TX", "Cross Roads TX", "Aubrey TX", "Pilot Point TX",
"Tioga TX", "Collinsville TX", "Whitesboro TX", "Sadler TX", "Southmayd TX",
"Pottsboro TX", "Denison TX", "Sherman TX", "Howe TX", "Van Alstyne TX",
"Anna TX", "Melissa TX", "Princeton TX", "Farmersville TX", "Nevada TX",
"Josephine TX", "Lavon TX", "Caddo Mills TX", "Greenville TX", "Royse City TX",
"Fate TX", "Rockwall TX", "Heath TX", "McLendon-Chisholm TX", "Sachse TX",
"Garland TX", "Richardson TX", "Plano TX", "Allen TX", "McKinney TX",
"Frisco TX", "The Colony TX", "Lewisville TX", "Carrollton TX", "Addison TX",
"Farmers Branch TX", "Coppell TX", "Irving TX", "Grand Prairie TX", "Arlington TX",
"Mansfield TX", "Burleson TX", "Crowley TX", "Fort Worth TX", "Benbrook TX",
"White Settlement TX", "River Oaks TX", "Westworth Village TX", "Westover Hills TX", "Edgecliff Village TX",
"Saginaw TX", "Blue Mound TX", "Haslet TX", "Keller TX", "Watauga TX",
"Haltom City TX", "Richland Hills TX", "North Richland Hills TX", "Colleyville TX", "Southlake TX",
"Grapevine TX", "Euless TX", "Bedford TX", "Hurst TX", "Fort Worth TX",
"Zürich Switzerland", "Basel Switzerland", "Bern Switzerland", "Lausanne Switzerland", "Lucerne Switzerland",
"St. Gallen Switzerland", "Winterthur Switzerland", "Lugano Switzerland", "Biel Switzerland", "Thun Switzerland",
"Bergen Norway", "Trondheim Norway", "Stavanger Norway", "Drammen Norway", "Fredrikstad Norway",
"Kristiansand Norway", "Sandnes Norway", "Tromsø Norway", "Sarpsborg Norway", "Skien Norway",
"Ålesund Norway", "Sandefjord Norway", "Haugesund Norway", "Tønsberg Norway", "Moss Norway",
"Porsgrunn Norway", "Bodø Norway", "Arendal Norway", "Hamar Norway", "Ytrebygda Norway",
"Larvik Norway", "Halden Norway", "Askøy Norway", "Molde Norway", "Horten Norway",
"Gjøvik Norway", "Lillehammer Norway", "Mo i Rana Norway", "Jessheim Norway", "Sandefjord Norway",
"Grimstad Norway", "Kongsberg Norway", "Harstad Norway", "Hønefoss Norway", "Åkrehamn Norway",
"Elverum Norway", "Askøy Norway", "Lillestrøm Norway", "Ski Norway", "Moss Norway"];


// Mom-focused keywords for SEO targeting
export const MOM_KEYWORDS = [
"mom", "moms", "mother", "mothers", "mommy", "mummy", "mama", "mum",
"parenting", "motherhood", "stay-at-home mom", "working mom", "busy mom",
"new mom", "first-time mom", "experienced mom", "mom life", "mom blogger",
"homeschool mom", "homeschooling", "educational activities for kids",
"children\'s development", "early childhood education", "Montessori mom",
"gentle parenting", "positive parenting", "mindful parenting",
"screen-free activities", "quality time with kids", "family activities",
"kids learning resources", "toddler activities", "preschool activities",
"kindergarten prep", "learning at home", "educational toys",
"creative play", "imaginative play", "quiet time activities",
"rainy day activities", "travel activities for kids", "car ride activities",
"waiting room activities", "restaurant activities for kids",
"gift ideas for kids", "birthday gifts", "holiday gifts for children",
"stocking stuffers", "Easter basket ideas", "Christmas gifts for kids",
"educational gifts", "learning gifts", "developmental toys",
"fine motor skills", "hand-eye coordination", "cognitive development",
"creativity for kids", "art activities", "coloring therapy",
"calm activities", "bedtime routine", "quiet activities",
"independent play", "self-directed learning", "Montessori activities",
"Waldorf education", "Reggio Emilia", "play-based learning",
"child-led learning", "hands-on learning", "sensory activities",
"STEM activities", "literacy activities", "numeracy skills",
"alphabet learning", "phonics activities", "reading readiness",
"writing practice", "tracing activities", "pre-writing skills",
"number recognition", "counting activities", "math readiness",
"shape recognition", "color learning", "pattern recognition",
"problem-solving skills", "critical thinking", "concentration activities",
"focus activities", "attention span", "patience building",
"confidence building", "self-esteem activities", "emotional development",
"social skills", "sharing activities", "cooperation skills",
"empathy building", "kindness activities", "character education",
"values education", "moral development", "life skills",
"independence skills", "self-care skills", "responsibility activities",
"organization skills", "time management for kids", "routine building",
"habit formation", "positive reinforcement", "reward systems",
"motivation for kids", "engagement activities", "fun learning",
"playful learning", "joyful learning", "love of learning",
"curiosity building", "exploration activities", "discovery learning",
"nature activities", "outdoor learning", "indoor activities",
"seasonal activities", "holiday activities", "themed activities",
"project-based learning", "unit studies", "thematic learning",
"integrated curriculum", "cross-curricular activities", "holistic education",
"whole child development", "balanced learning", "well-rounded education"];


// Generate location-based keywords
export function generateLocationKeywords(baseKeyword: string): string[] {
  const topLocations = HIGH_INCOME_LOCATIONS.slice(0, 50); // Use top 50 for keyword generation
  return topLocations.map((location) => `${baseKeyword} ${location}`);
}

// Generate comprehensive keywords for a page
export function generatePageKeywords(baseKeywords: string[]): string[] {
  const locationKeywords = baseKeywords.flatMap((keyword) =>
  generateLocationKeywords(keyword).slice(0, 10) // Top 10 locations per keyword
  );

  const momKeywords = baseKeywords.flatMap((keyword) =>
  MOM_KEYWORDS.slice(0, 30).map((momKeyword) => `${keyword} for ${momKeyword}`)
  );

  return [...baseKeywords, ...locationKeywords.slice(0, 50), ...momKeywords.slice(0, 50)];
}

// Generate Schema.org structured data for Organization
export function generateOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "My Happy Place Digital",
    "url": "https://myhappypla4132.builtwithrocket.new",
    "logo": "https://images.unsplash.com/photo-1632479734663-a742f1c4ef88",
    "description": "Premium children's coloring books, alphabet books, and educational resources for mothers in high-income areas worldwide. Trusted by 50,000+ families.",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+256-764-590167",
      "contactType": "Customer Service",
      "email": "myhappyplacedigital@gmail.com",
      "availableLanguage": ["English"]
    },
    "sameAs": [
    "https://www.instagram.com/myhappyplacedigital",
    "https://www.facebook.com/myhappyplacedigital",
    "https://twitter.com/myhappyplacedig",
    "https://www.pinterest.com/myhappyplacedigital"],

    "address": {
      "@type": "PostalAddress",
      "addressCountry": "US"
    },
    "areaServed": HIGH_INCOME_LOCATIONS.slice(0, 100),
    "audience": {
      "@type": "Audience",
      "audienceType": "Mothers, Parents, Educators",
      "geographicArea": HIGH_INCOME_LOCATIONS.slice(0, 100)
    }
  };
}

// Generate Schema.org structured data for Product
export function generateProductSchema(product: {
  name: string;
  description: string;
  image: string;
  price: number;
  currency?: string;
  availability?: string;
  brand?: string;
  sku?: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.name,
    "description": product.description,
    "image": product.image,
    "brand": {
      "@type": "Brand",
      "name": product.brand || "My Happy Place Digital"
    },
    "offers": {
      "@type": "Offer",
      "price": product.price.toFixed(2),
      "priceCurrency": product.currency || "USD",
      "availability": product.availability || "https://schema.org/InStock",
      "url": "https://myhappypla4132.builtwithrocket.new/products",
      "seller": {
        "@type": "Organization",
        "name": "My Happy Place Digital"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "2847",
      "bestRating": "5",
      "worstRating": "1"
    },
    "audience": {
      "@type": "Audience",
      "audienceType": "Mothers, Parents, Educators in high-income areas"
    },
    "sku": product.sku || `MHP-${product.name.replace(/\s+/g, '-').toUpperCase()}`
  };
}

// Generate Schema.org structured data for WebSite
export function generateWebSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "My Happy Place Digital",
    "url": "https://myhappypla4132.builtwithrocket.new",
    "description": "Premium children's educational books and coloring books for mothers in high-income areas worldwide",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://myhappypla4132.builtwithrocket.new/products?search={search_term_string}",
      "query-input": "required name=search_term_string"
    },
    "publisher": {
      "@type": "Organization",
      "name": "My Happy Place Digital",
      "logo": {
        "@type": "ImageObject",
        "url": "https://myhappypla4132.builtwithrocket.new/assets/images/MHP_-1771696153902.png"
      }
    }
  };
}

// Generate Schema.org structured data for BreadcrumbList
export function generateBreadcrumbSchema(items: {name: string;url: string;}[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
}

// Generate FAQ Schema
export function generateFAQSchema(faqs: {question: string;answer: string;}[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
}

// Generate ItemList Schema for product collections
export function generateItemListSchema(products: {name: string;url: string;image: string;}[]) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": products.map((product, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": product.name,
      "url": product.url,
      "image": product.image
    }))
  };
}

// Generate comprehensive meta description with location and mom targeting
export function generateMetaDescription(baseDescription: string, includeLocations = true): string {
  const topLocations = HIGH_INCOME_LOCATIONS.slice(0, 15).join(", ");
  const locationSuffix = includeLocations ?
  ` Serving mothers and families in ${topLocations}, and 285+ more high-income areas worldwide.` :
  "";

  return `${baseDescription}${locationSuffix}`.slice(0, 160);
}

// Generate Open Graph metadata
export function generateOpenGraphMetadata({
  title,
  description,
  url,
  image,
  type = "website"






}: {title: string;description: string;url: string;image: string;type?: string;}) {
  return {
    title,
    description,
    url,
    siteName: "My Happy Place Digital",
    locale: "en_US",
    type,
    images: [
    {
      url: image,
      width: 1200,
      height: 630,
      alt: title
    }]

  };
}

// Generate Twitter Card metadata
export function generateTwitterMetadata({
  title,
  description,
  image




}: {title: string;description: string;image?: string;}) {
  return {
    card: "summary_large_image",
    title,
    description,
    ...(image && { images: [image] })
  };
}